var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"window-position",style:({ left: _vm.x + 'px', bottom: _vm.b + 'px' })},[_c('surround-box',{attrs:{"background":"#223446"}},[_c('div',{staticClass:"content-box",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }